import loadable from '@loadable/component';

export const LazyRsvpAnswersIframe = loadable(() => import(/* webpackChunkName: "content/rsvp/iframe" */ '.'));
